import { useState, useEffect } from 'react';

let isGoogleChartsLoaded = false;
const subscribers = new Set();

// Ensure this code runs only in the browser
if (typeof window !== 'undefined' && window.google) {
  // Load the Visualization API and the required packages.
  window.google.charts.load('current', { packages: ['corechart', 'geochart'] });

  // Set a callback to run when the Google Visualization API is loaded.
  window.google.charts.setOnLoadCallback(() => {
    isGoogleChartsLoaded = true;
    subscribers.forEach(callback => callback());
    subscribers.clear();
  });
}

/**
 * A React hook that returns true once the Google Charts library is loaded and ready.
 * It uses a singleton pattern to ensure the loader is initialized only once.
 *
 * @returns {boolean} indicating if the library is loaded.
 */
export const useGoogleCharts = () => {
  const [isLoaded, setIsLoaded] = useState(isGoogleChartsLoaded);

  useEffect(() => {
    if (isLoaded) {
      return;
    }

    // Define the subscriber function for this component instance.
    const newSubscriber = () => {
      setIsLoaded(true);
    };

    // Add the subscriber to the set.
    subscribers.add(newSubscriber);

    // Return a cleanup function to remove the subscriber on unmount.
    return () => {
      subscribers.delete(newSubscriber);
    };
  }, [isLoaded]);

  return isLoaded;
};